import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, Select } from "antd";
import ResolutionAlarmIcon from "../../../../assets/resolution-alaram-icon.svg";
function ResolutionDropdown(props) {
  const { parentId, onApply } = props;
  const [state, setState] = useState({
    isOpen: false,
    data: {
      duration: "7 days",
      resolution: "15 minutes",
    },
  });

  function handleOpenChange(val) {
    if (val === false) {
      if (state.isOpen) {
        setState((prev) => ({ ...prev, isOpen: false }));
      }
    } else {
      setState((prev) => ({ ...prev, isOpen: val }));
    }
  }
  function handleDurationChange(val) {
    setState((prev) => ({ ...prev, data: { ...prev.data, duration: val } }));
  }
  function handleResolutionChange(val) {
    setState((prev) => ({ ...prev, data: { ...prev.data, resolution: val } }));
  }
  function handleCancel(e) {
    e.preventDefault();
    setState((prev) => ({
      ...prev,
      isOpen: false,
      data: {
        duration: "7 days",
        resolution: "15 minutes",
      },
    }));
  }
  function handleApply(e) {
    e.preventDefault();
    onApply({ ...state.data });
    setState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }
  const items = [
    {
      label: (
        <div>
          <span className="font-face-vzw">Filter</span>
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div className="d-flex flex-column justify-content-center align-items-start">
          <span>Duration</span>
          <Select
            getPopupContainer={() => document.getElementById(`${parentId}`)}
            value={state.data.duration}
            style={{
              width: "216px",
              height: "44px",
            }}
            onSelect={handleDurationChange}
            options={[
              {
                value: "5 minutes",
                label: "5 Minutes",
              },
              {
                value: "10 minutes",
                label: "10 Minutes",
              },
              {
                value: "15 minutes",
                label: "15 Minutes",
              },
              {
                value: "20 minutes",
                label: "20 Minutes",
              },
              {
                value: "30 minutes",
                label: "30 Minutes",
              },
              {
                value: "60 minutes",
                label: "60 Minutes",
              },
              {
                value: "2 hours",
                label: "2 Hours",
              },
              {
                value: "3 hours",
                label: "3 Hours",
              },
              {
                value: "4 hours",
                label: "4 Hours",
              },
              {
                value: "6 hours",
                label: "6 Hours",
              },
              {
                value: "12 hours",
                label: "12 Hours",
              },
              {
                value: "24 hours",
                label: "24 Hours",
              },
              {
                value: "2 days",
                label: "2 Days",
              },
              {
                value: "3 days",
                label: "3 Days",
              },
              {
                value: "7 days",
                label: "7 Days",
              },
              {
                value: "10 days",
                label: "10 Days",
              },
              {
                value: "14 days",
                label: "14 Days",
              },
              {
                value: "20 days",
                label: "20 Days",
              },
              {
                value: "30 days",
                label: "30 Days",
              },
              {
                value: "45 days",
                label: "45 Days",
              },
              {
                value: "60 days",
                label: "60 Days",
              },
              {
                value: "90 days",
                label: "90 Days",
              },
              {
                value: "120 days",
                label: "120 Days",
              },
              {
                value: "180 days",
                label: "180 Days",
              },
            ]}
          />
          <span>Resolution</span>
          <Select
            getPopupContainer={() => document.getElementById(`${parentId}`)}
            value={state.data.resolution}
            style={{
              width: "216px",
              height: "44px",
            }}
            onSelect={handleResolutionChange}
            options={[
              {
                value: "15 minutes",
                label: "15 Minutes",
              },
              {
                value: "30 minutes",
                label: "30 Minutes",
              },
              {
                value: "60 minutes",
                label: "60 Minutes",
              },
              {
                value: "2 hours",
                label: "2 Hours",
              },
              {
                value: "3 hours",
                label: "3 Hours",
              },
              {
                value: "4 hours",
                label: "4 Hours",
              },
              {
                value: "6 hours",
                label: "6 Hours",
              },
              {
                value: "12 hours",
                label: "12 Hours",
              },
              {
                value: "24 hours",
                label: "24 Hours",
              },
              {
                value: "3 days",
                label: "3 Days",
              },
              {
                value: "7 days",
                label: "7 Days",
              },
            ]}
          />
          <div className="w-100 d-flex flex-row justify-content-between align-items-center my-2">
            <div>
              <button
                className="explorer-filter-apply-btn"
                style={{ width: "68px", height: "32px", padding: "0px" }}
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
            <div>
              <button
                className="explorer-filter-apply-btn"
                style={{
                  width: "68px",
                  height: "32px",
                  padding: "0px",
                  backgroundColor: "#000",
                  color: "#fff",
                }}
                type="button"
                onClick={handleApply}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      ),
      key: "1",
    },
  ];

  return (
    <Dropdown
      menu={{
        items,
      }}
      open={state.isOpen}
      onOpenChange={handleOpenChange}
      trigger={["click"]}
      getPopupContainer={() => document.getElementById(`${parentId}`)}
    >
      <div>
        <img
          className="resolution-icon"
          src={ResolutionAlarmIcon}
          alt="resolution setting Icon"
        />
      </div>
    </Dropdown>
  );
}

ResolutionDropdown.propTypes = {
  parentId: PropTypes.string.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default ResolutionDropdown;
